import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SHeroImageWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  overflow: hidden;

  @media ${BREAKPOINTS.MD.max} {
    position: unset;
    max-height: 40vh;
    flex: 1;
    width: 100%;
    object-fit: cover;
    object-position: top;
    margin-bottom: 1rem;
  }
`
